export { Body, type BodyProps } from './body'
export { Foot, type FootProps } from './foot'
export { Head, type HeadProps } from './head'
export { Columns, type ColumnsProps } from './columns'
export { Panel, type PanelProps } from './panel'
